import * as React from 'react';
import { createComponent, EventName } from '@lit-labs/react';
import { YotpoButton as Component } from '@yotpo-common/ui-components/components/button';

export const YotpoButton = createComponent({
	react: React,
	tagName: 'yotpo-button',
	elementClass: Component,
	events: {
		onClick: 'click' as EventName<MouseEvent>
	}
});
